import { useEffect, useState } from 'react';
import { PageSteps } from '../../../components/sales/sales-common/NewHeader';
import { isStockOrder } from '../../constants';
import { querySalesEntityWithToken } from '@utils/serverActions/clientUtility';
import { getCachedToken } from '@config/authentication';
import { SALES_ENTITY } from '@common/interfaces/entity';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { setServiceContract, setServiceContractLoading } from '@store/slices/serviceContractSlice';
import { selectOrderId } from '@store/selectors';

interface IServiceContract {
  sku?: string;
  serialNo?: string;
  activeStep: PageSteps;
  createdOrderType: string;
  isVarebilEnabled: boolean;
  isUsedCar: boolean;
  isForeignBrand: boolean;
}

export const useClientServiceContract = ({
  serialNo,
  sku,
  activeStep = null,
  createdOrderType,
  isUsedCar,
  isVarebilEnabled,
  isForeignBrand,
}: IServiceContract) => {
  const queryCall = isVarebilEnabled
    ? [PageSteps.IMPORTEROPTIONS, PageSteps.SIGN]
    : [PageSteps.FINANACE, PageSteps.IMPORTEROPTIONS];

  const [loading, setLoading] = useState(false);
  const [responseObject, setResponseObject] = useState(null);
  const dispatch = useAppDispatch();
  const nextOrderId = useAppSelector(selectOrderId);
  const fetchServiceContract = async () => {
    setLoading(true);
    dispatch(setServiceContractLoading(true));
    try {
      if (serialNo) {
        const variables = {
          serialNo: serialNo,
        };
        const data = await querySalesEntityWithToken(
          SALES_ENTITY.SERVICE_CONTRACT,
          getCachedToken(),
          variables,
          undefined,
          undefined,
          nextOrderId
        );
        setResponseObject(data?.responseObject);
        dispatch(setServiceContract(data?.responseObject));
      } else if (sku) {
        const variables = {
          sku: sku,
        };
        const data = await querySalesEntityWithToken(
          SALES_ENTITY.SERVICE_CONTRACT_BY_SKU,
          getCachedToken(),
          variables,
          undefined,
          undefined,
          nextOrderId
        );
        setResponseObject(data?.responseObject);
        dispatch(setServiceContract(data?.responseObject));
      }
    } catch (error) {
      console.error('Error fetching service contract:', error);
    } finally {
      setLoading(false);
      dispatch(setServiceContractLoading(false));
    }
  };

  useEffect(() => {
    if (queryCall.includes(activeStep) && !isStockOrder(createdOrderType) && !isUsedCar && !isForeignBrand) {
      fetchServiceContract();
    } else {
      return;
    }
  }, [serialNo, sku, activeStep]);

  const response = {
    data: responseObject?.contractTypeList?.length ? responseObject : null,
    loading,
  };

  return response;
};
